import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormHostDirective} from "../../../../../shared/directive/form-host.directive";
import {roles} from "../../../../../shared/constants/common.constants";
import {ParticipantInfoFormComponent} from "../components/participant-info-form/participant-info-form.component";
import {AdultInfoFormComponent} from "../components/adult-info-form/adult-info-form.component";
import {CoachInfoFormComponent} from "../components/coach-info-form/coach-info-form.component";
import {ClientAdminInfoFormComponent} from "../components/client-admin-info-form/client-admin-info-form.component";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {role} from "../../../../core/authentication.selectors";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-step-five-right-panel',
  templateUrl: './step-five-right-panel.component.html',
  styleUrls: ['./step-five-right-panel.component.css']
})
export class StepFiveRightPanelComponent implements OnInit, OnDestroy {
  private readonly onDestroy: Subject<any> = new Subject<any>();

  @ViewChild(FormHostDirective, {static: true}) formHost!: FormHostDirective;
  invitedUserRole: number;
  component: any;

  constructor(
    private store: Store<fromRoot.State>,
  ) {
    this.store
      .select(role)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.invitedUserRole = data;
      })
  }

  ngOnInit() {
    switch (this.invitedUserRole) {
      case roles['participant']:
        this.component = ParticipantInfoFormComponent;
        break;
      case roles['adult']:
        this.component = AdultInfoFormComponent;
        break;
      case roles['coach']:
        this.component = CoachInfoFormComponent;
        break;
      case roles['clientAdmin']:
        this.component = ClientAdminInfoFormComponent;
        break;
      default:
        this.component = ParticipantInfoFormComponent;
        break;
    }
    this.loadComponent();
  }

  loadComponent() {
    // get container reference
    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    // create setting component
    viewContainerRef.createComponent(
      this.component
    ).location.nativeElement.classList.add('user-detail-form');

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
